export const DocumentType = {
    LOT: "LOT",
    PRODUCT: "PRODUCT",
    LABORATORY: "LABORATORY",
    COMPANY_LOGO: "COMPANY_LOGO",
}